import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private isLoading = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this.isLoading.asObservable();

  private progress = new BehaviorSubject<number>(0);
  public readonly progress$ = this.progress.asObservable();

  public isError = new BehaviorSubject<boolean>(false);

  private activeRequests = 0;
  private progressInterval?: Subscription;

  show() {
    this.activeRequests++;
    this.isLoading.next(true);
    this.startProgress();
  }

  hide() {
    if (this.activeRequests > 0) {
      this.activeRequests--;
    }

    if (this.activeRequests === 0) {
      // this.activeRequests = 0;
      this.completeProgress();
    }
  }

  private startProgress() {
    if (this.progressInterval) {
      return;
    }

    this.progress.next(0);
    this.progressInterval = interval(40).subscribe(() => {
      const newProgress = Math.min(this.progress.value + 1, 90);
      this.progress.next(newProgress);
    });
  }

  private completeProgress() {

    this.progress.next(100);
    // Ensure we only unsubscribe if progress is active
    if (this.progressInterval) {
      this.progressInterval.unsubscribe();
      this.progressInterval = undefined;
    }

    setTimeout(() => {
      if (this.activeRequests === 0) {
        this.progress.next(0);
        this.isLoading.next(false);
        // Reset progress after a short delay
      }
    }, 500);
  }
}
